import {Async, Loaded, Empty, Loading, toPage} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {WorkQueueItem} from 'ApplicationEntry/models/WorkQueueItem';
import {Page} from 'Core/models/Page';
import {ApplicationType} from 'ApplicationEntry/models/ApplicationType';

export enum WorkQueueActionType {
  LOAD_WORK_ITEMS = 'workQueue/LOAD_WORK_ITEMS',
  GET_WORK_ITEMS = 'workQueue/GET_WORK_ITEMS',
  VIEW_WORK_ITEM_IMAGE = 'workQueue/VIEW_WORK_ITEM_IMAGE',
  GET_APP_ENTRY_TYPE = 'workQueue/GET_APP_ENTRY_TYPE',
  ADD_WORK_ITEM = 'workQueue/ADD_WORK_ITEM',
}

export const getAppEntryType = (awdWorkKey: string, applicationType?: ApplicationType, workType?: string) =>
  createAction(WorkQueueActionType.GET_APP_ENTRY_TYPE, {awdWorkKey, applicationType, workType});
export const getWorkItems = () => {
  return createAction(WorkQueueActionType.GET_WORK_ITEMS);
};
export const loadWorkItems = (workQueueItems: Loaded<WorkQueueItem[]>) =>
  createAction(WorkQueueActionType.LOAD_WORK_ITEMS, {workQueueItems});
export const viewWorkItemImage = (id: string) => createAction(WorkQueueActionType.VIEW_WORK_ITEM_IMAGE, {id});
export const addWorkItem = (workQueueItem: WorkQueueItem) =>
  createAction(WorkQueueActionType.ADD_WORK_ITEM, {workQueueItem});

type WorkQueueState = Async<Page<WorkQueueItem>>;
const DEFAULT_STATE = new Empty();

type WorkQueueAction =
  | ReturnType<typeof loadWorkItems>
  | ReturnType<typeof getWorkItems>
  | ReturnType<typeof addWorkItem>;

export default (state: WorkQueueState = DEFAULT_STATE, action: WorkQueueAction): WorkQueueState => {
  switch (action.type) {
    case WorkQueueActionType.GET_WORK_ITEMS:
      return new Loading<Page<WorkQueueItem>>();
    case WorkQueueActionType.LOAD_WORK_ITEMS:
      return new Loaded(toPage(action.payload.workQueueItems.Data));
    case WorkQueueActionType.ADD_WORK_ITEM:
      const newState = {...state};
      const workItems = newState.key === 'Loaded' ? newState.Data.result : [];
      workItems.push(action.payload.workQueueItem);
      return new Loaded(toPage(workItems));
    default:
      return state;
  }
};
